import { apiSlice } from '../app/api/apiSlice';
import { setBuyRequests, setResolutionType, setRewardType, setStrategyType, updateBuyRequest, addBuyRequestsSafe, setDisapprovalReason, setLostReason, updateSwarms, updateEvents, addBuyRequestsArrSafe, updateBuyRequests } from '../store/slices/swarms';
import { EventAdapter } from '../adapters/eventAdapters.js'
import queryString from 'query-string';

export const swarmsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({ 
    events: builder.mutation({ // in the near future we could transform this into a query so data may be cached
      query: params => ({
        url: 'swarms/events',
        method: 'POST',
        body: params || { "orderColumns": [{ "columnName": "name", "orderType": "asc" }], "filterColumns": [] }
      })
    }),
    // New version without dispatch side effects
    getSwarmsPure: builder.query({
      query: (query) => `swarms${typeof (query) === "string" ? query : typeof(query)==="object" ? query.query : ""}`,
      keepUnusedDataFor: 0,
      transformResponse: (data) => {
        const adaptedEvents = data.events.map(eventData => EventAdapter(eventData));
        return {
          ...data,
          events: adaptedEvents
        }
      }
      // Without onQueryStarted to avoid dispatches and side effects
    }),
    getSwarms: builder.query({
      query: (query) => `swarms${typeof (query) === "string" ? query : typeof(query)==="object" ? query.query : ""}`,
      keepUnusedDataFor: 0,
      transformResponse: (data) => {
        const adaptedEvents = data.events.map( eventData => EventAdapter(eventData));
        return {
          ...data,
          events: adaptedEvents
        }
      },
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('getSwarms side-Effect, start...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('getSwarms side-Effect, success: ', data)
          dispatch(updateSwarms(data.swarms))
          dispatch(updateEvents(data.events))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('getSwarms side-Effect, error: ', err)
          throw err
        }
      }
    }),
    getSwarmsInAction: builder.query({
      query: () => 'swarms/in-action',
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
        } catch (error) {
          console.error('Error fetching SwarmsInAction:', error);
          throw error;
        }
      },
    }),

    getDissaprobalReason: builder.query({
      query: (query) => `Swarms/disapproval-reason`,
      keepUnusedDataFor: 200,
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('getDissaprobalReason side-Effect, start...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('getDissaprobalReason side-Effect, success: ', data)
          dispatch(setDisapprovalReason(data))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('getDissaprobalReason side-Effect, error: ', err)
          throw err
        }
      }
    }),
    getLostReason: builder.query({
      query: (query) => `Swarms/lost-reason`,
      keepUnusedDataFor: 0,
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('getLostReason side-Effect, start...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('getLostReason side-Effect, success: ', data)
          dispatch(setLostReason(data))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('getLostReason side-Effect, error: ', err)
          throw err
        }
      }
    }),
    createSwarm: builder.mutation({
      query: params => ({
        url: 'swarms/create-swarm',
        method: 'POST',
        body: params
      })
    }),
    editFlaggedSwarm: builder.mutation({
      query: body => ({
        url: 'swarms/edit-flagged-swarm',
        method: 'PUT',
        body: body
      })
    }),
    getBuyRequest: builder.query({
      //query: (q = {}) => '/Swarms/buy-requests/?' + Object.entries(q).reduce((p, x) => p + `${x[0]}=${x[1]}&`, '').slice(0, -1),
      // Function that generates a query string for the API request
      query: (q = {}) => {
        const { extraOptions, ...query } = q;
        // Convert the input object 'q' into a list of key-value pairs
        // Then, reduce this list to a single query string
        let queryString = Object.entries(query).reduce((p, [key, value]) => {

          // If the value associated with the key is an array (e.g., SwarmResolutionTypeId)
          if (Array.isArray(value)) {
            // Construct a query string for each value in the array
            // For example, it converts [1, 2] into "SwarmResolutionTypeIds=1&SwarmResolutionTypeIds=2"
            return p + value.map(v => `${key}=${v}`).join('&') + '&';
          }

          // If it's not an array, simply add the key-value pair to the string
          return p + `${key}=${value}&`;

        }, ''); // The initial value for reduce is an empty string

        // Return the full URL, removing the extra '&' at the end
        return '/Swarms/buy-requests/?' + queryString.slice(0, -1);
      },
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('getBuyRequest, success: ', data)

          const buyRequests = data.buyRequests;

          const { extraOptions } = queryArg;
          if (extraOptions)
            dispatch(addBuyRequestsArrSafe(buyRequests))
          else
            dispatch(setBuyRequests(buyRequests))
        } catch (err) {
          if (err.error?.originalStatus === 401) {
            return;
          }
          console.log('getBuyRequest, error: ', err)
          throw err
        }
      },
      keepUnusedDataFor: 0,
      providesTags: (result, error, arg) => [
        { type: 'buyRequests', id: 'LIST' },
      ]
    }),
    getUserBuyRequests: builder.query({
      query: () => ({
        url: '/Swarms/user-buy-requests'
      }),
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('getBuyRequest, success: ', data)

          const buyRequests = data.buyRequests;

          if(buyRequests?.length > 0)
          {
            dispatch(updateBuyRequests(buyRequests))
            
            // get swarms for these buys requests in order to get the events info displayed in them
            const swarmIds = buyRequests.map(BR => BR.swarmId).filter((value, index, self) => self.indexOf(value) === index);
            const swarmIdsQueryString = swarmIds.map(id => `Id=${id}`).join('&');
            try {
              dispatch(swarmsApi.endpoints.getSwarms.initiate(`?${swarmIdsQueryString}`));
            } catch (error) {
              if (error.status == 401) return; //error managed on baseQueryWithReauth
              if (error.status == 404){
                console.error("Swarm not found, swarmId: " + swarmIdsQueryString," ", JSON.stringify(error))
                throw error
              }
              throw error
            }
          }
        } catch (err) {
          if (err.error?.originalStatus === 401) {
            return;
          }
          console.log('getBuyRequest, error: ', err)
          throw err
        }
      },
      keepUnusedDataFor: 0,
      providesTags: (result, error, arg) => [
        { type: 'buyRequests', id: 'LIST' },
      ]
    }),
    createBuyRequest: builder.mutation({
      query: params => ({
        url: '/Swarms/buy-requests',
        method: 'POST',
        body: params
      }),
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('addBuyRequest, success: ', data)
          dispatch(addBuyRequestsSafe(data))
        } catch (err) {
          if (err.error?.originalStatus === 401) return;
          console.log('addBuyRequest, error: ', err)
          throw err
        }
      },
    }),
    editBuyRequest: builder.mutation({
      query: body => ({
        url: '/Swarms/buy-requests',
        method: 'PUT',
        body: body
      }),
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('editBuyRequest, success: ', data)
          dispatch(updateBuyRequest(data))
        } catch (err) {
          if (err.error?.originalStatus === 401) return;
          console.log('editBuyRequest, error: ', err)
          throw err
        }
      },
    }),
    editSwarm: builder.mutation({
      query: editedSwarm => ({
        url: 'swarms',
        method: 'PUT',
        body: editedSwarm
      })
    }),
    editOrCreateSwarm: builder.mutation({
      query: editedSwarm => ({
        url: 'swarms/EditOrCreateSwarm',
        method: 'PUT',
        body: editedSwarm
      })
    }),
    getResolutionType: builder.query({
      query: () => '/Swarms/resolution-type',
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('getResolutionType, success: ', data)
          dispatch(setResolutionType(data))
        } catch (err) {
          if (err.error?.originalStatus === 401) return;
          console.log('getResolutionType, error: ', err)
          throw err
        }
      },
      keepUnusedDataFor: 0,
      providesTags: (result, error, arg) => [
        { type: 'resolutionType', id: 'LIST' },
      ]
    }),
    getRewardType: builder.query({
      query: () => '/Swarms/reward-type',
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('getRewardType, success: ', data)
          dispatch(setRewardType(data))
        } catch (err) {
          if (err.error?.originalStatus === 401) return;
          console.log('getRewardType, error: ', err)
          throw err
        }
      },
      keepUnusedDataFor: 0,
      providesTags: (result, error, arg) => [
        { type: 'rewardType', id: 'LIST' },
      ]
    }),
    getStrategyType: builder.query({
      query: () => '/Swarms/strategy-type',
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('getStrategyType, success: ', data)
          dispatch(setStrategyType(data))
        } catch (err) {
          if (err.error?.originalStatus === 401) return;
          console.log('getStrategyType, error: ', err)
          throw err
        }
      },
      keepUnusedDataFor: 0,
      providesTags: (result, error, arg) => [
        { type: 'strategyType', id: 'LIST' },
      ]
    }),
    createSwarmPurchase: builder.mutation({
      query: params => ({
        url: '/Swarms/Purchase',
        method: 'POST',
        body: params
      }),
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('createSwarmPurchase, success: ', data)
        } catch (err) {
          if (err.error?.originalStatus === 401) return;
          console.log('createSwarmPurchase, error: ', err)
          throw err
        }
      },
    }),
    getRequestsMetrics: builder.query({
      query: () => '/Swarms/buy-requests/metrics',
      keepUnusedDataFor: 0,
    }),
    getBuyRequestsAssignedManager: builder.query({
      query: (query) => `/Swarms/buy-requests/assigned-manager?${query}`,
      keepUnusedDataFor: 0,
    }),
    hideEvents: builder.mutation({
      query: body => ({
        url: '/Swarms/hide-events',
        method: 'POST',
        body: body
      }),
      invalidatesTags: ["HiddenEvents"]
    }),
    unhideAllEvents: builder.mutation({
      query: body => ({
        url: '/Swarms/unhide-all-events',
        method: 'POST'
      }),
      invalidatesTags: ["HiddenEvents"]
    }),
    getHiddenEvents: builder.query({
      query: () => ({
        url: '/Swarms/hidden-events',
        method: 'Get',
      }),
      providesTags: ['HiddenEvents'],
    }),
    //A: here pass means reject all BuyRequests
    buyRequestsPassAll: builder.mutation({
      query: body => ({
        url: '/Swarms/buy-requests/pass-all/' + body.swarmId,
        method: 'PUT',
        body: body
      }),
    }),
    getSwarmsMetrics: builder.query({
      query: (query) => `/Swarms/swarm-metrics${query ? `?${queryString.stringify(query)}` : ''}`,
      keepUnusedDataFor: 0,
    }),
    buyRequestsApproveAll: builder.mutation({
      query: body => ({
        url: '/Swarms/buy-requests/approve-all/' + body.swarmId,
        method: 'PUT',
        body: body
      }),
    }),
    getUniqueRequesters: builder.query({
      query: ({ startDate, endDate }) => ({
        url: `/Swarms/unique-requesters?startDate=${startDate}&endDate=${endDate}`,
        method: 'GET',
      }),
    }),
    getUniqueBuyers: builder.query({
      query: ({ startDate, endDate }) => ({
        url: `/Swarms/unique-buyers?startDate=${startDate}&endDate=${endDate}`,
        method: 'GET',
      }),
    }),

    lostPurchase: builder.mutation({
      query: body => ({
        url: '/Swarms/lost-purchase',
        method: 'POST',
        body: body,
      }),
    }),

    getLostMainReasonSubReason: builder.query({
      query: () => ({
        url: '/Swarms/buy-requests/lost-main-reason-sub-reason',
        method: 'Get',
      }),
    }),

  })
})

export const {
  useEventsMutation, useCreateSwarmMutation, useGetSwarmsQuery,
  useLazyGetSwarmsQuery, useGetSwarmsPureQuery, useEditSwarmMutation,
  useLazyGetBuyRequestQuery, useGetBuyRequestQuery, useCreateBuyRequestMutation, useEditBuyRequestMutation,
  useGetResolutionTypeQuery, useGetRewardTypeQuery, useGetStrategyTypeQuery,
  useGetDissaprobalReasonQuery, useGetLostReasonQuery, useCreateSwarmPurchaseMutation, useGetRequestsMetricsQuery, useLazyGetRequestsMetricsQuery,
  useLazyGetBuyRequestsAssignedManagerQuery, useHideEventsMutation, useUnhideAllEventsMutation, useLazyGetHiddenEventsQuery, useGetUserBuyRequestsQuery, useLazyGetUserBuyRequestsQuery,
  useEditFlaggedSwarmMutation,
  useGetSwarmsInActionQuery,
  useBuyRequestsPassAllMutation,
  useGetSwarmsMetricsQuery, useLazyGetSwarmsMetricsQuery,
  useEditOrCreateSwarmMutation,
  useBuyRequestsApproveAllMutation,
  useGetUniqueRequestersQuery,
  useGetUniqueBuyersQuery,
  useLostPurchaseMutation,
  useGetLostMainReasonSubReasonQuery,
} = swarmsApi;